import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
const BlogButton = () => {
  const buttonRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    setShowTooltip(true);
    buttonRef.current.scrollIntoView({ behavior: "smooth", block: "center" });

    const timeout = setTimeout(() => {
      setShowTooltip(false);
    }, 5000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="relative inline-block mt-4" ref={buttonRef}>
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute -top-2  transform text-black text-sm px-2 py-2 rounded shadow-lg animate-fade-in z-10"></div>
      )}

      {/* Button wrapped in <a> to make it clickable */}
      <Link to="/farmblogs">
        <button className="px-5 py-2 rounded bg-green-600 text-white font-semibold shadow-md animate-pulse hover:bg-green-700 transition">
          Our Blogs
        </button>
      </Link>
    </div>
  );
};

export default BlogButton;
